module.exports = __webpack_public_path__ + "img/IMG_9000_L_Wood_MockedUp.cf288f58.jpg";